import React from 'react';

import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';

import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import './styles.scoped.css';
import { TablePagination } from '../../../components';
import { money } from '../../../utils';

const columnClassName = 'align-middle text-nowrap';

export const arAgingColumns = [
  {
    Header: 'Bill To#',
    accessor: 'BillToNumber',
    className: columnClassName,
  },
  {
    Header: 'Bill To Name',
    accessor: 'BillToName',
    className: columnClassName,
  },
  {
    Header: 'Invoice #',
    accessor: 'Invoice_Number',
    className: columnClassName,
  },
  {
    Header: 'Trans Date',
    accessor: 'Trans_Date',
    className: columnClassName,
  },
  {
    Header: 'Trans Code',
    accessor: 'Trans_Code',
    className: columnClassName,
  },
  {
    Header: 'Transaction Amount',
    accessor: 'Trans_Amount',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'Transaction Balance',
    accessor: 'Trans_Balance',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: '0-30',
    accessor: 'Aging_Thirty',
    className: columnClassName,
  },
  {
    Header: '31-60',
    accessor: 'Aging_Sixty',
    className: columnClassName,
  },
  {
    Header: '61-90',
    accessor: 'Aging_Nighty',
    className: columnClassName,
  },
  {
    Header: 'Over 90',
    accessor: 'Aging_Over_Nighty',
    className: columnClassName,
  },
  {
    Header: 'Future Cash On Account',
    accessor: 'Future_Cash_On_Account',
    className: columnClassName,
  },
  {
    Header: 'Less Cash On Account',
    accessor: 'Less_Cash_On_Account',
    className: columnClassName,
  },
  {
    Header: 'Account Balance',
    accessor: 'Account_Balance',
    className: columnClassName,
    Cell: instance => money.format(instance.value),
  },
  {
    Header: 'CR Limit',
    accessor: 'Credit_Limit',
    className: columnClassName,
  },
  {
    Header: 'Last Pay',
    accessor: 'Last_Pay',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'Job Branch',
    accessor: 'JobBranch',
    className: columnClassName,
  },
];

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const ARAgingReportTable = ({ data, loading }) => {
  const tableInstance = useTable(
    {
      columns: arAgingColumns,
      data,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ARAgingReportTable;
